<template>
    <div class="form-group form-group--textarea has-effect" :style="customStyle">
        <div class="has-effect-input">
            <textarea
                v-model="mutableValue"
                :readonly="readonly"
                class="textarea form-control"
                :class="[
                    { 'has-content': mutableValue },
                    { 'is-invalid': invalid },
                    { 'resize-none': !resize }
                ]"
                :name="name"
                :minlength="minlength"
                :maxlength="maxlength"
                :disabled="disabled"
                @keydown="onKeyPress"
            />

            <label class="form-label is-textarea" :for="textareaName">
                <span v-if="label" v-text="label" />
                <span v-if="required" v-text="'*'" class="text-danger pl-1" />
            </label>

            <div
                v-if="maxlength"
                ref="taCounter"
                v-text="`${value.length} / ${maxlength}`"
                class="textarea__counter text-sm"
                :class="{ 'text-danger': value.length >= maxlength }"
            />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        minlength: {
            type: Number,
            default: 0
        },
        maxlength: {
            type: Number,
            required: false
        },
        label: {
            type: String,
            default: ''
        },
        value: {
            type: String,
            default: ''
        },
        required: {
            type: Boolean,
            default: false
        },
        textareaName: {
            type: String,
            required: false
        },
        customStyle: {
            type: String,
            required: false
        },
        invalid: {
            type: Boolean,
            default: false
        },
        invalidFeedback: {
            type: String,
            required: false,
            default: 'Wystąpił błąd'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        resize: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        mutableValue: {
            get() {
                return this.value
            },
            set(value) {
                if (value.length >= this.maxlength) {
                    value = value.slice(0, this.maxlength)
                }

                this.$emit('input', value)
            }
        },

        signsCount() {
            return this.value.length
        },

        name() {
            return this.textareaName || `textarea-${this._uid}`
        }
    },
    methods: {
        onKeyPress(event) {
            if (this.maxlength && this.value.length >= this.maxlength && event.key !== 'Backspace') {
                this.$refs.taCounter.classList.add('pulse')

                setTimeout(() => {
                    this.$refs.taCounter.classList.remove('pulse')
                }, 500)
            }
        }
    }
}
</script>

<style lang="scss">
@import '../../../styles/custom.scss';

.form-group--textarea{
    .resize-none {
        resize: none;
    }
    .has-effect-input{
        width: 100%;
        height: 100%;

        .textarea.form-control{
            width: 100%;
            height: 100%;
            border: 1px solid var(--color-gray-200);
            border-radius: 0.3125rem;
        }
    }

    .textarea__counter{
        position: absolute;
        bottom: 5px;
        right: 10px;
        color: var(--color-gray-400);
        user-select: none;

        &.pulse {
            animation: pulse 0.5s;
        }
    }
}

@keyframes pulse {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.1);
    }
    100% {
        transform: scale(1);
    }
}
</style>